<template>
  <div class="color-official-colors">
    <b-tabs content-class="mt-3" v-model="getCurrentSubStep">
      <b-tab title="Primary color" active>
        <p>
          <color-picker
            :colors="orderedColors"
            :results="results"
            :reference="'primaryColor'"
            v-on:set-color-event="setPrimaryColor"
          ></color-picker>
        </p>
      </b-tab>
      <b-tab title="Secondary color" v-if="!secondaryColorLocked">
        <div class="mb-3">
          <div class="uppercase xs-text mt-3 xs-content">You can select the same primary and secondary and have only one color used for your components/bike.</div>
          <div class="uppercase xs-text mt-3 xs-content" v-if="bikeId == 16">The secondary color is only visible on the inside of the fork.</div>
        </div>
        <p>
          <color-picker
            :colors="orderedSecondaryColors"
            :results="results"
            :reference="'secondaryColor'"
            v-on:set-color-event="setSecondaryColor"
          ></color-picker>
        </p>
      </b-tab>
    </b-tabs>
  </div>
</template>

<script>
import Vue from "vue";

import colorPicker from "../sub-components/color-picker.vue";
import {
  isOt01BrushedColor,
  sortBrushedColorsFirst,
  supportsSecondaryColor,
} from "../../../../utils/colourRules";

Vue.component("color-picker", colorPicker);

export default {
  name: "color-official-colors",
  data() {
    return {
    };
  },
  props: ["results", "colors", "currentTab", "bikeId", "componentsConfig"],
  computed: {
    orderedColors: function () {
      return sortBrushedColorsFirst(this.colors);
    },
    secondaryColors: function () {
      if (!Array.isArray(this.colors)) {
        return [];
      }

      const withoutSurcharge = this.colors.filter(
        (color) => Number(color && color.price ? color.price : 0) <= 0
      );

      const allowedNames = this.secondaryColorNamesFromLayers();
      if (allowedNames.size === 0) {
        return withoutSurcharge;
      }

      return withoutSurcharge.filter((color) => color && allowedNames.has(color.name));
    },
    orderedSecondaryColors: function () {
      return sortBrushedColorsFirst(this.secondaryColors);
    },
    secondaryColorLocked: function () {
      const price = Number(
        this.results &&
        this.results.colour &&
        this.results.colour.primaryColorPrice != null
          ? this.results.colour.primaryColorPrice
          : 0
      );
      const primaryColor =
        this.results && this.results.colour
          ? this.results.colour.primaryColor
          : null;

      return (
        !supportsSecondaryColor(this.bikeId) ||
        price > 0 ||
        isOt01BrushedColor(this.bikeId, primaryColor)
      );
    },
    getCurrentSubStep: {
      get: function() {
        return this.currentTab;
      },
      set: function(e) {
        this.$emit("current-substep", e);
      }
    }

  },
  methods: {
    secondaryColorNamesFromLayers: function () {
      const names = new Set();
      const config = this.componentsConfig;

      if (!config || typeof config !== "object") {
        return names;
      }

      Object.values(config).forEach((group) => {
        if (!Array.isArray(group)) {
          return;
        }
        group.forEach((row) => {
          if (
            Number(row.component_type_id) === 25 &&
            row.color != null &&
            row.color_type != null &&
            Number(row.color_type) === 1
          ) {
            names.add(row.color);
          }
        });
      });

      return names;
    },
    setPrimaryColor: function (e) {
      this.$emit("set-primary-color", e);
    },
    setSecondaryColor: function (e) {
      this.$emit("set-secondary-color", e);
    },
  },
};
</script>

<style lang="scss" scoped>
.color-official-colors {
  margin-bottom: 50px;
}
</style>
